import { render, staticRenderFns } from "./BannerCard.vue?vue&type=template&id=4a9e824a&scoped=true&"
import script from "./BannerCard.vue?vue&type=script&lang=js&"
export * from "./BannerCard.vue?vue&type=script&lang=js&"
import style0 from "./BannerCard.vue?vue&type=style&index=0&id=4a9e824a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9e824a",
  null
  
)

export default component.exports